import { createAction } from '@reduxjs/toolkit';
import { EtfBackendViewModel } from './backend';
import { ReturnMapTreeNode } from './redux-model';

export const SET_ETFS = createAction<EtfBackendViewModel[]>("SET_ETFS");
export const SET_DATA_SOURCES = createAction<EtfBackendViewModel[]>("SET_DATA_SOURCES");
export const SET_SETTING_CURRENCY = createAction<string>("SET_SETTING_CURRENCY");
export const SET_SETTING_COLOR = createAction<string>("SET_SETTING_COLOR");
export const SET_SETTING_SIZE = createAction<string>("SET_SETTING_SIZE");
export const SET_SETTING_GROUP_LEVEL1 = createAction<string>("SET_SETTING_GROUP_LEVEL1");
export const SET_SETTING_GROUP_LEVEL2 = createAction<string>("SET_SETTING_GROUP_LEVEL2");
export const SET_SETTING_TRADE_STATUS = createAction<string>("SET_SETTING_TRADE_STATUS");
export const SET_TREE_ROOT = createAction<ReturnMapTreeNode>("SET_TREE_ROOT");
